export default __webpack_public_path__ + "static/media/SiauliuBankas.ef894cd7.svg";